import { isSuccess } from '@orus.eu/result'

import { hasEndorsementCreationPermission } from './endorsement-availability.utils.ts'

import { sessionManager } from '#/lib/session.ts'

/**
 * Reads the session outside React, for a route `beforeLoad`. Returns false when the session is
 * unavailable (outdated client): no prefetch, and the action stays hidden.
 */
export async function loadCanCreateEndorsement(): Promise<boolean> {
  const sessionResult = await sessionManager.getSessionResult()
  if (!isSuccess(sessionResult)) return false
  return hasEndorsementCreationPermission(sessionResult.output.allPermissions)
}
